import React, { useMemo, useState } from "react";
import MxAutoCompleteField from "./MxAutoCompleteField/MxAutoCompleteField";
import { MxAutoCompleteFieldProps } from "./MxAutoCompleteField/model/MxAutoCompleteField";
import HCheckArray from "@rf-helper/check-have-value";
import { useGetListOwnerQuery } from "@/src-refactor/modules/store/qrtk/services/owners/owners.qrtk";
import MxItemOwnerWithConflict from "@rf-l1/items-autocomplete/MxItemOwnerWithConflict";
import {
  ownerAutoCompleteItem,
  ownerAutoCompleteItemAdapter
} from "@rf/adapters/autocomplete-items/ownerItemAdapters";

type omit = "items";
export type MxSelectOwnersFieldProp = Omit<MxAutoCompleteFieldProps, omit>;
const MxSelectOwnersField = (props: MxSelectOwnersFieldProp) => {
  const [search, onSearch] = useState("");
  const GET_Owners = useGetListOwnerQuery({
    query: {
      q: search ?? ""
    }
  });

  const Items: ownerAutoCompleteItem[] = useMemo(() => {
    const items = GET_Owners?.data?.data!;
    if (HCheckArray(items)) {
      return items.map(owner =>
        ownerAutoCompleteItemAdapter({
          name: owner.name,
          id: owner.id,
          identification: owner.identification,
          isConflictive: Boolean(owner.is_conflictive || 0),
          requiredConflictEvaluation: Boolean(owner.is_conflictive || 0),
          formData: null
        })
      );
    }
    return [];
  }, [GET_Owners.data]);

  return (
    <MxAutoCompleteField
      {...props}
      onSearch={v => onSearch(v)}
      isSearch={true}
      items={Items}
      loading={GET_Owners.isLoading}
      componentItem={MxItemOwnerWithConflict}
    />
  );
};

export default MxSelectOwnersField;
